<template>
  <div class="ma-2 ml-3 site_content">
    <div class="flex s-bt">
      <comboFarm
        @fromFarm="farmInfo"
      />
      
      <img :src="icon_raw" class="icon_size" @click="MilkRaw(farmData)"/>
    </div>

    <div class="chart flex">
      <div class="month">
        <div class="tab-container flex">
          <div> 월별 </div>
          <div class="tab-content">
            <button class="tab mr-1" 
              :class="{ active: selectedmTab === 'mCnt' }" 
              @click="selectemTab('mCnt')">
              착유량 | 횟수
            </button>
            <button class="tab mr-1"
              :class="{ active: selectedmTab === 'mCond' }" 
              @click="selectemTab('mCond')">
              유지방 | 유단백
            </button>
            <button class="tab"
              :class="{ active: selectedmTab === 'mTemp' }" 
              @click="selectemTab('mTemp')">
              체온 | 전도도
            </button>
          </div>

          <div>
            <button
              class="reset_btn" 
              @click="resetmDate()">
              <v-icon color="white" size="20">
                mdi-redo-variant
                mdi-rotate-180
              </v-icon>
            </button>
          </div>
        </div>

        <div class="chart-container">
          <!-- 이전버튼 -->
          <button class="prev-btn" >
            <v-icon color="white" @click="prevmDate()">mdi-chevron-left</v-icon>
          </button> 
          <!-- {{ this.mstand_date }} -->

          <div class="chart_layout">
            <Chart
            chartType="Bar"
            :chartData="monthChart"
            :chartOptions="lineBarOptions"
            :chartSize="chartSize"
          />
          </div>

          <!-- 다음버튼 -->
          <button class="next-btn" v-if="!isMonth">
            <v-icon color="white" @click="nextmDate()">mdi-chevron-right</v-icon>
          </button>
        </div>
      </div>
  
      <div class="day ml-5">
        <div class="tab-container flex">
          <div> 일별 </div>
          <div class="tab-content">
            <button class="tab mr-1" 
              :class="{ active: selectedTab === 'dCnt' }" 
              @click="selectTab('dCnt')">
              착유량 | 횟수
            </button>
            <button class="tab mr-1"
              :class="{ active: selectedTab === 'dCond' }" 
              @click="selectTab('dCond')">
              유지방 | 유단백
            </button>
            <button class="tab"
              :class="{ active: selectedTab === 'dTemp' }" 
              @click="selectTab('dTemp')">
              체온 | 전도도
            </button>
          </div>

          <div>
            <button
              class="reset_btn" 
              @click="resetDate()">
              <v-icon color="white" size="20">
                mdi-redo-variant
                mdi-rotate-180
              </v-icon>
            </button>
          </div>
        </div>

        <div class="chart-container">
          <!-- 이전버튼 -->
          <button class="prev-btn" >
            <v-icon color="white" @click="prevDate()">mdi-chevron-left</v-icon>
          </button> 

          <div class="chart_layout">
            <Chart
              chartType="Bar"
              :chartData="dayChart"
              :chartOptions="lineBarOptions"
              :chartSize="chartSize"
            />
          </div>

          <!-- 다음버튼 -->
          <button class="next-btn" v-if="!isToday">
            <v-icon color="white" @click="nextDate()">mdi-chevron-right</v-icon>
          </button>
        </div>
      </div>
    </div>

    <!--일별 테이블-->
    <div class="flex vertical-center mt-3 mb-info">
      <div class="mr-1 milk-table">
        <h4 class="ml-3">
          <v-icon color="black" size="18">mdi-calendar-check</v-icon>
          일별 평균 착유정보
        </h4>

        <div v-if="loading" class="loading-container">
          <div class="spinner"></div>
        </div>

        <div class="table_layout" v-else>
          <MilkTable 
          :headers="headers"
          :items="redayData"
          @detailInfo="detailDayInfo"/>
        </div>
      </div>

      <div class="milk-table">
        <h4 class="ml-3">
          <v-icon color="black">mdi-cow</v-icon>
          {{this.pickDate }} 개체 평균 정보
        </h4>

        <div v-if="loading" class="loading-container">
          <div class="spinner"></div>
        </div>

        <div class="table_layout" v-else>
          <dayMilkTable 
            :headers="dayheaders"
            :items="dayPickData"
            :search="search"
            @detailInfo="detailcowInfo"/>
        </div>
      </div>
    </div>

    <!-- 개체통계 -->
     <div v-show="cowInfoTable" class="mt-3">
      <div class="detail_info"> 🥛 {{ entityNo(this.entity_no) }} 의 {{ this.pickDate }} 회차별 정보 </div>

      <div class="table_layout cowtable_layout">
        <cowTable 
          :headers="cowheaders"
          :items="cowInfo"/>
      </div>
     </div>


  </div>
</template>


<script>
import Apis from '@/api/apis';
import dateUtil from "@/utils/custom/dateProperty.js";

import comboFarm from "@/components/combo/farm.vue";
import MilkTable from "@/views/trace/MilkTable/MilkTable.vue";
import dayMilkTable from "@/views/trace/MilkTable/dayMilkTable.vue";
import cowTable from "@/views/trace/MilkTable/cowTable.vue";
import Chart from "@/components/chart/Chart.vue"
import { lineBarOptions, lineChartOptions } from "@/components/chart/option.js";  // 옵션 불러오기

export default {
  name: 'NewMilk',
  components:{
    comboFarm,
    Chart,
    MilkTable,
    dayMilkTable,
    cowTable
  },
  async created() {
    Apis.getIpClient((res) => {
      // console.log(res);  
      let client = res
      Apis.pageCount({ //페이지뷰 카운터
        page_name: `${client.city}/${client.country}/${client.region}/${client.loc}/${client.org}/${client.postal}/${client.timezone}`,
        url: this.$route.path,
        ip: client.ip,
        division: "cloud",
      },() => {  // 정상처리
        // console.log("pageCount 호출",res);
      }).catch( (err) => {  // 개별 API 오류 처리 예제
        console.log("pageCount 호출 오류",err);
      });
    }).catch( (err) => {  // API 오류 처리
        console.log("getIpClient 호출 오류",err)
    }) 

  },
  watch:{
    selectedmTab(){
      this.monthChart = this.drawMonthlyChart();
    },
    selectedTab(){
      this.dayChart = this.drawDayChart();
    },
    stand_date(oldVal,newVal){
      if(oldVal !== newVal){
        this.dayMilkTable = false;
        this.cowInfoTable = false;
      }
    },
    pickDate(oldVal,newVal){
      if(oldVal !== newVal){
        this.cowInfoTable = false;
      }
    }
  },
  computed: {
    isToday() {
      let today = dateUtil.format(new Date(), "yyyy-MM-dd");
      return this.stand_date === today;
    },
    isMonth() {
      let today = dateUtil.format(new Date(), "yyyy-MM-dd");
      return this.mstand_date === today;
    }
  },
  data(){
    return{
      farmData: { company: {}, farm: {} },
      icon_raw: require("@/assets/pack/raw_data.svg"),


      selectedmTab:'mCnt',
      selectedTab:'dCnt',

      stand_date:dateUtil.format(new Date(), "yyyy-MM-dd"),
      mstand_date:dateUtil.format(new Date(), "yyyy-MM-dd"),

      lineBarOptions:lineBarOptions,
      lineChartOptions:lineChartOptions,

      monthItem:{},
      monthChart :{},
      monthData:[],
      pickDate:'',
      
      dayItem:{},
      dayChart:{},
      dayData:[],
      redayData:[],

      //일별 평균
      headers:[
        { value: "date", text: "착유일자", align: 'center'},
        { value: "", text: "개체", align: 'center'},
        { value: "result.total_milking_wt", text: "착유량 kg", align: 'center'},
        { value: "result.total_milking_cnt", text: "회차", align: 'center'},
        { value: "result.milking_mtime_per_kg", text: "시간 초", align: 'center'},
        { value: "result.avg_mfat_rt", text: "유지방 %", align: 'center'},
        { value: "result.avg_mprt_rt", text: "유단백 %", align: 'center'},
        { value: "result.avg_temp", text: "체온 ℃", align: 'center'},
        { value: "result.avg_cond", text: "전도도", align: 'center'},
      ],

      dayheaders:[
        { value: "entity_no", text: "식별번호", sortable: true , align: 'center'},
        { value: "", text: "상세" , align: 'center'},
        { value: "total_milking_cnt", text: "회차", align: 'center'},
        { value: "total_milking_wt", text: "착유량 kg", align: 'center'},
        { value: "parities", text: "산차", align: 'center'},
        { value: "milking_mtime_per_kg", text: "시간 초", align: 'center'},
        { value: "avg_mfat_rt", text: "유지방 %", align: 'center'},
        { value: "avg_mprt_rt", text: "유단백 %", align: 'center'},
        { value: "avg_temp", text: "체온 ℃", align: 'center'},
        { value: "avg_cond", text: "전도도", align: 'center'},
      ],

      cowheaders:[
        { value: "milking_cnt", text: "착유회차", align: 'center'},
        { value: "milking_wt", text: "착유량 kg", align: 'center'},
        { value: "milking_s_dt", text: "시작시간", align: 'center'},
        { value: "milking_e_dt", text: "종료시간", align: 'center'},
        { value: "mfat", text: "유지방 %", align: 'center'},
        { value: "mprt", text: "유단백 %", align: 'center'},
        { value: "cond", text: "전도도 %", align: 'center'},
        { value: "temp", text: "체온 ℃", align: 'center'},

      ],


      //daypick 상세 
      dayMilkTable:false,
      dayPickData:[],
      search:'',

      // 개체 상세
      cowInfoTable:false,
      cowInfo:[],
      entity_no:'',

      chartSize: {
        height:'20vh',
        width: '100%',
      },
      daychartSize: {
        height:'20px',
        width: '100%',
      },

      loading:false,

    }
  },
  methods:{
    farmInfo(data){
      // console.log(data)
      this.farmData = data;
      this.refreshData();
    },
    selectemTab(value) {
      this.selectedmTab = value;
    },
    selectTab(value){
      this.selectedTab = value;
    },
    entityNo(entity){
      if (!entity) return "";
      return entity.replace(/^(\d{3})(\d{5})(\d{3})(\d)$/, "$1 $2 $3 $4");
    },
    refreshData(){
      this.monthlyMilk();
      this.dailyData();
    },
    MilkRaw(farmData){
      // console.log(farmData)
      this.$router.push({
        name: "rawData",
        params: { 
          farm:{code: farmData.farm.code, name: farmData.farm.name},
          typeCode: "PC04"
          // type:{code:'PC04', name:'로봇착유기 낙농'}
         }
      });
    },
    monthlyMilk(){
      Apis.statisticsOfDairyMilkMonthly({
        "farm_cd" : this.farmData.farm.code,
        "stand_date" : this.mstand_date,
        "month" : 13
      },(res) => {
        if (res.result) {
        this.monthData = res.data;

				let date = [];
        let mCnt = []; // 홧수
        let mtotal = []; //착유량
        let mfat = []; //지방
        let mprt = []; //단백질
        let mtemp = []; //온도
        let mcond = []; //전도도

        this.monthData.forEach((item) => {
          // console.log(item)
          date.push(item.date);
          mCnt.push(item.result.total_milking_cnt);
          mtotal.push(item.result.total_milking_wt);
          mfat.push(item.result.avg_mfat_rt);
          mprt.push(item.result.avg_mprt_rt);
          mtemp.push(item.result.avg_temp);
          mcond.push(item.result.avg_cond)
        });

        this.monthItem = {
          date : date,
          mCnt : mCnt,
          mtotal : mtotal,
          mfat : mfat,
          mprt : mprt,
          mtemp : mtemp,
          mcond : mcond
        };

        // console.log(this.monthItem)
      
				this.monthChart = this.drawMonthlyChart();
        } else {
          alert(res.message);
        }
        this.loading = false;
      }).catch( (err) => {  // API 오류 처리
          console.log("statisticsOfDairyMilkMonthly API 호출 오류",err);
          this.loading = false;
      })
    },

    drawMonthlyChart() {
      let datasets = [];

      const dataLength = (this.monthItem.date || []).length;
      const dynamicBarPercentage = dataLength < 5 ? 0.4 : 0.8;

      if (this.selectedmTab === "mCnt") {
        datasets = [
          {
            type: "line",
            label: "착유횟수",
            data: this.monthItem.mCnt,
            backgroundColor: "rgba(111, 207, 151, 0.6)",
            borderColor: "rgba(111, 207, 151, 0.6)",
            yAxisID: "y1",
          },
          {
            type: "bar",
            label: "착유량",
            data: this.monthItem.mtotal,
            backgroundColor: "rgba(135, 206, 235, 0.3)",
            borderColor: "rgba(135, 206, 235, 0.3)",
            yAxisID: "y2",
            barPercentage: dynamicBarPercentage,
          },
        ];
      } else if (this.selectedmTab === "mCond") {
        datasets = [
          {
            type: "line",
            label: "유지방",
            data: this.monthItem.mfat,
            backgroundColor: "rgba(255, 99, 132, 0.6)",
            borderColor: "rgba(255, 99, 132, 0.6)",
            yAxisID: "y1",
          },
          {
            type: "line",
            label: "유단백",
            data: this.monthItem.mprt,
            backgroundColor: "rgba(54, 162, 235, 0.3)",
            borderColor: "rgba(54, 162, 235, 0.3)",
            yAxisID: "y2",
            barPercentage: dynamicBarPercentage,
          },
        ];
      } else if (this.selectedmTab === "mTemp") {
        datasets = [
          {
            type: "line",
            label: "체온",
            data: this.monthItem.mtemp,
            backgroundColor: "rgba(255, 206, 86, 0.6)",
            borderColor: "rgba(255, 206, 86, 0.6)",
            yAxisID: "y1",
          },
          {
            type: "line",
            label: "전도도",
            data: this.monthItem.mcond,
            backgroundColor: "rgba(75, 192, 192, 0.3)",
            borderColor: "rgba(75, 192, 192, 0.3)",
            yAxisID: "y2",
            barPercentage: dynamicBarPercentage,
          },
        ];
      }
      // console.log("monthly datasets:", datasets);
      return{
        labels:this.monthItem.date,
        datasets: datasets,
      }
    },
    dailyData(){
      this.loading = true;
      // console.log(this.stand_date)
      Apis.statisticsOfDairyMilkDaily({
        "farm_cd" : this.farmData.farm.code,
        "stand_date" : this.stand_date,
        "day" : 31
      },(res) => {
        if (res.result) {
        this.dayData = res.data;
        this.redayData = res.data.reverse();
        
				let date = [];
        let dCnt = []; // 홧수
        let dtotal = []; //착유량
        let dfat = []; //지방
        let dprt = []; //단백질
        let dtemp = []; //온도
        let dcond = []; //전도도

        this.dayData.forEach((item) => {
          // console.log(item)
          date.push(item.date.substring(5,16));
          dCnt.push(item.result.total_milking_cnt);
          dtotal.push(item.result.total_milking_wt);
          dfat.push(item.result.avg_mfat_rt);
          dprt.push(item.result.avg_mprt_rt);
          dtemp.push(item.result.avg_temp);
          dcond.push(item.result.avg_cond)
        });

        this.dayItem = {
          date : date,
          dCnt : dCnt,
          dtotal : dtotal,
          dfat : dfat,
          dprt : dprt,
          dtemp : dtemp,
          dcond : dcond
        };

        // console.log(this.dayItem)
				this.dayChart = this.drawDayChart();

        if (this.redayData.length > 0) {
          this.pickDate = this.redayData[0].date;
          this.detailDayInfo(this.pickDate);
        }
        } else {
          alert(res.message);
        }
        this.loading = false;
      }).catch( (err) => {  // API 오류 처리
          console.log("statisticsOfDairyMilkDaily API 호출 오류",err);
          this.loading = false;
      })
    },
    drawDayChart(){
      let datasets = [];

      if (this.selectedTab === "dCnt") {
        datasets = [
          {
            type: "line",
            label: "착유횟수",
            data: this.dayItem.dCnt,
            backgroundColor: "rgba(111, 207, 151, 0.6)",
            borderColor: "rgba(111, 207, 151, 0.6)",
            yAxisID: "y1",
          },
          {
            type: "bar",
            label: "착유량",
            data: this.dayItem.dtotal,
            backgroundColor: "rgba(135, 206, 235, 0.3)",
            borderColor: "rgba(135, 206, 235, 0.3)",
            yAxisID: "y2",
          },
        ];
      } else if (this.selectedTab === "dCond") {
        datasets = [
          {
            type: "line",
            label: "유지방",
            data: this.dayItem.dfat,
            backgroundColor: "rgba(255, 99, 132, 0.6)",
            borderColor: "rgba(255, 99, 132, 0.6)",
            yAxisID: "y1",
          },
          {
            type: "line",
            label: "유단백",
            data: this.dayItem.dprt,
            backgroundColor: "rgba(54, 162, 235, 0.3)",
            borderColor: "rgba(54, 162, 235, 0.3)",
            yAxisID: "y2",
          },
        ];
      } else if (this.selectedTab === "dTemp") {
        datasets = [
          {
            type: "line",
            label: "체온",
            data: this.dayItem.dtemp,
            backgroundColor: "rgba(255, 206, 86, 0.6)",
            borderColor: "rgba(255, 206, 86, 0.6)",
            yAxisID: "y1",
          },
          {
            type: "line",
            label: "전도도",
            data: this.dayItem.dcond,
            backgroundColor: "rgba(75, 192, 192, 0.3)",
            borderColor: "rgba(75, 192, 192, 0.3)",
            yAxisID: "y2",
          },
        ];
      }
      // console.log("dayitem", this.dayItem);
      return{
        labels:this.dayItem.date.reverse(),
        datasets: datasets,
      }
    },
    //월별 날짜
    prevmDate(){
      // console.log(this.stand_date)
      let cdate = new Date(this.mstand_date);
      let prevdate = new Date(cdate.setDate(cdate.getDate() - 180));

      this.mstand_date = dateUtil.format(prevdate, "yyyy-MM-dd");
      // console.log("바뀐", this.stand_date)

      this.monthlyMilk();

    },
    nextmDate(){
      let cdate = new Date(this.mstand_date);
      let nextdate = new Date(cdate.setDate(cdate.getDate() + 180));

      this.mstand_date = dateUtil.format(nextdate, "yyyy-MM-dd");
      // console.log("바뀐", this.stand_date)

      this.monthlyMilk();
    },
    resetmDate(){
      this.mstand_date = dateUtil.format(new Date(), "yyyy-MM-dd");
      this.monthlyMilk();
    },
    
    //날짜
    prevDate(){
      // console.log(this.stand_date)
      let cdate = new Date(this.stand_date);
      let prevdate = new Date(cdate.setDate(cdate.getDate() - 31));

      this.stand_date = dateUtil.format(prevdate, "yyyy-MM-dd");
      // console.log("바뀐", this.stand_date)

      this.dailyData();

    },
    nextDate(){
      let cdate = new Date(this.stand_date);
      let nextdate = new Date(cdate.setDate(cdate.getDate() + 31));

      this.stand_date = dateUtil.format(nextdate, "yyyy-MM-dd");
      // console.log("바뀐", this.stand_date)

      this.dailyData();
    },
    resetDate(){
      this.stand_date = dateUtil.format(new Date(), "yyyy-MM-dd");
      this.dailyData();
    },
    detailDayInfo(item){
      // console.log(item)
      Apis.statisticsOfDairyMilkPerEntity({
        "farm_cd" : this.farmData.farm.code,
        "from" : item,
        "to" : item
        },(res) => {  
        if (res.result) {
          this.dayMilkTable = true;

          this.pickDate = item;
          this.dayPickData = res.data;

        } else {
          alert(res.message);
        }
      }).catch( (err) => {  // API 오류 처리
          console.log("statisticsOfDairyMilkPerEntity API 호출 오류",err)
      })
    },
    detailcowInfo(item){
      // console.log(item)
      Apis.listDairyMilk({
        "entity_no" : item,
        "from" : this.pickDate,
        "to" : this.pickDate
        },(res) => {  
        if (res.result) {
          this.cowInfoTable = true;

          // console.log(res.data)

          this.cowInfo = res.data;
          this.entity_no = item;

        } else {
          alert(res.message);
        }
      }).catch( (err) => {  // API 오류 처리
          console.log("listDairyMilk API 호출 오류",err)
      })
    }

  }
}
</script>

<style lang="scss" scoped>
@import '../../style/base.scss';
@import '../../style/table_mb.scss';

.combo_box{
  width:270px !important;
  display:flex !important;
  margin-top:5px !important;
  // box-shadow: 0 2px 3px rgba(0, 0, 0, 0.3) !important; /* 그림자 효과 */
}
.icon_size{
  cursor: pointer;
}
.farm_cb{
  width:230px !important;
}
.chart{
  justify-content: center;
  margin-top:10px;
  border-radius: 20px;
  background-color: #FAFBFB;
  padding:5px 10px 20px 10px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
}
.chart_layout{
  border: 1px solid rgb(214, 214, 214) !important;
  box-shadow: none !important;
  width:35vw !important;
}
::v-deep .farm_cb .v-input__slot{
  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.3) !important; /* 그림자 효과 */
}
.table_layout, .daytable_layout{
  padding:0 !important;
  margin-top:10px;
  height:25vh;
}
.daytable_layout{
  height:22vh !important;
}
.cowtable_layout{
  height:auto !important;
}
.search{
  max-width:120px;
}

.chart-container {
  margin-top:-10px;
  display: flex;
  align-items: center;
}
.chart_layout {
  width: 100%;
  max-height: 400px; 
  overflow: hidden;
}
.prev-btn, .next-btn {
  padding: 5px;
  background-color: #005b96;
  color: white;
  border-radius: 25px;
  z-index:2;
  cursor: pointer;
  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.3) !important; /* 그림자 효과 */
}
.prev-btn{
  margin-right:-20px;
}
.next-btn{
  margin-left:-20px;
}
.tab-container{
  justify-content: center;
  align-items: center;
}
.tab-container div{
  font-weight:600;
  letter-spacing: -1.25px;
  color:#4a4a4a;
  margin-right:5px;
}
.tab-content {
  display: inline-flex;
  padding:5px;
  // background-color: #F3F3F3;
  border-radius: 5px;
  overflow: hidden; /* 버튼이 탭 영역을 넘지 않도록 */
  height: 45px;
}
.tab {
  margin-top:3px;
  flex: 1;
  width:95px;
  height:30px;
  letter-spacing: -1px;
  font-size:14px !important;
  font-weight:600 !important;

  border-radius: 20px;
  border: none;
  background-color: #e7e7e7;
  color: #bababa; 
  cursor: pointer;
  transition: all 0.5s ease;
}

.tab.active {
  background-color: $point-color; 
  color: white;
  font-weight:600;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.2); 
}

.tab:not(.active):hover {
  background-color: #f0f0f0; 
}
.loading-container{
  background-color: white;
  border-radius: 30px;
  margin-top:10px;
  height:18vh;
  display:flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
}
.detail_info{
  font-size:15px;
  letter-spacing: -1px;
  margin-top:20px;
  margin-left:10px;
  font-weight:550;
}
.reset_btn{
  border-radius: 50%;
  background-color: $main-color !important;
  width:25px !important;
  height:25px !important;
  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.3) !important; /* 그림자 효과 */
}
.milk-table{
  width:49.5%;
}
@media only screen and (max-width: 768px){
  .chart_layout{
    width:95% !important; 
  }
  .tab{
    width:80px;
  }
  .day{
    margin-left:-10px !important;
  }
  .mb-info{
    flex-direction: column;
  }
  .milk-table{
    width:100%;
  }
}
</style>
